"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var theme = _a.theme, margin = _a.margin;
    if (!margin) {
        return '';
    }
    if (Array.isArray(margin) && margin.length >= 1 && margin.length <= 4) {
        return "margin: " + margin.map(function (size) { return theme.sizes.default[size] || 'auto'; }).join(' ') + ";";
    }
    console.error('Please provide an array (max 4 elements) for `margin` style helper.');
    return '';
});
